<div [attr.data-testid]="id" [attr.data-styletarget]="'iq-media-video__container'">
    <div
        [attr.data-testid]="id + '-player'"
        [attr.data-styletarget]="'iq-media-video-player__body'"
        #videoPlayer
    ></div>
</div>
